export default __webpack_public_path__ + "static/media/Button Set 1.b5c3706f.svg";